module.exports = __webpack_public_path__ + "img/orthopedic-card-features.df3b64ac.jpg";